import { clsx } from 'clsx';
import { Switch } from 'antd';
import { makeStyles } from '@mui/styles';
import { useEffect, useState } from 'react';
import { LockOutlined } from '@ant-design/icons';

import { LightTooltip } from '@components';


interface Props {
  defaultValue?: boolean;
  labelLeft?: string;
  labelRight?: string;
  isFixed?: boolean;
  isFixedText?: string;
  onChange?: (value: boolean) => void;
  disabled?: boolean;
  className?: string;
  labelClassName?: string;
}

export const SwitcherControllerInput = ({
  defaultValue, labelLeft, labelRight, onChange, disabled, className, labelClassName,
  isFixed, isFixedText,
}: Props) => {
  const cls = useStyles();
  const [isChecked, setChecked] = useState(defaultValue ?? false);

  const switchValue = () => {
    if (isFixed) return;
    const newValue = !isChecked;
    setChecked(newValue);
    onChange && onChange(newValue);
  };

  useEffect(() => {
    setChecked(defaultValue ?? false);
  }, [defaultValue]);

  return (
    <div className={clsx(cls.box, className)}>
      <div className={clsx(cls.label, labelClassName)}>{labelLeft}</div>
      <div className={cls.switcher} onClick={e => e.stopPropagation()}>
        <Switch
          defaultChecked={isChecked}
          onChange={switchValue}
          className={clsx(cls.checkbox, isChecked && cls.checkboxChecked)}
          disabled={disabled}
        />
        {isFixed && isFixedText ? (
          <LightTooltip title={isFixedText}>
            <LockOutlined className={cls.lockIcon} />
          </LightTooltip>
        ) : null}
      </div>
      <div className={clsx(cls.label, labelClassName)}>{labelRight}</div>
    </div>
  );
};

const useStyles = makeStyles({
  box: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'var(--font-primary)',
  },
  label: {
    color: 'var(--title-color)',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1,
    width: '30%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  switcher: {
    width: '40%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    paddingLeft: 15,
    paddingRight: 15,
  },
  checkbox: {
    verticalAlign: 'top',
    height: 20,
    width: 55,
    minWidth: 55,
    background: 'var(--foreground-color)',
    border: '1px solid var(--switcher-border-color)',
    opacity: 1,

    '& > div': {
      left: '1px !important',
      top: 1,
      width: 24,
      boxShadow: 'none',
      height: '16px !important',

      '&::before': {
        backgroundColor: 'var(--primary-color)',
      },
    },
  },
  checkboxChecked: {
    '& > div': {
      left: 'auto !important',
      right: 1,

      '&::before': {
        backgroundColor: 'var(--primary-color)',
        boxShadow: '-1px 1px 3px rgba(0,0,0,0.8)',
      },
    },
  },
  lockIcon: {
    marginLeft: 5,
    fontSize: 18,
    color: 'var(-mutted-color)',
  },
});
